import {
  LayoutDashboard, ShoppingBag, Users, Package, Megaphone, Target,
  FileBarChart, PlusCircle, Building2, Wallet, Radio, GitCompare, FolderTree, IdCard, ClipboardCheck, ShieldPlus, Award, Gem, Settings2, ListChecks,
} from "lucide-react";

export const PAGES = [
  { to: "/", label: "Panel", icon: LayoutDashboard },
  { to: "/live", label: "Canlı Panel", icon: Radio },
  { to: "/opening", label: "Açılış Listesi", icon: ListChecks },
  { to: "/day-end", label: "Gün Sonu Raporu", icon: ClipboardCheck },
  { to: "/sales/new", label: "Satış Girişi", icon: PlusCircle },
  { to: "/sales", label: "Satışlar", icon: ShoppingBag, personel: "Satışlarım" },
  { to: "/products", label: "Ürünler", icon: Package, adminOnly: true },
  { to: "/catalogs", label: "Kataloglar", icon: FolderTree, adminOnly: true },
  { to: "/campaigns", label: "Kampanyalar", icon: Megaphone, adminOnly: true },
  { to: "/targets", label: "Hedefler", icon: Target, mudur: "Şube Hedefi", personel: "Hedefim" },
  { to: "/users", label: "Kullanıcılar", icon: Users, adminOnly: true },
  { to: "/roles", label: "Roller", icon: ShieldPlus, adminOnly: true },
  { to: "/branches", label: "Şubeler", icon: Building2, adminOnly: true },
  { to: "/payroll", label: "Hakediş Bordrosu", icon: Wallet, personel: "Hakedişlerim" },
  { to: "/wallet", label: "Cüzdan", icon: Wallet, personel: "Cüzdanım" },
  { to: "/id-archive", label: "Kimlik Arşivi", icon: IdCard },
  { to: "/comparison", label: "Karşılaştırma", icon: GitCompare },
  { to: "/reports", label: "Raporlar", icon: FileBarChart },
  { to: "/profile", label: "Rozet Vitrini", icon: Award },
  { to: "/ypp", label: "Yatırımcı Performans Primi", icon: Gem },
  { to: "/settings", label: "Ayarlar", icon: Settings2 },
];

export const ROLE_DEFAULTS = {
  koordinator: PAGES.map((p) => p.to),
  patron: ["/", "/opening", "/live", "/day-end", "/sales", "/targets", "/payroll", "/wallet", "/id-archive", "/comparison", "/reports", "/profile", "/ypp", "/settings"],
  mudur: ["/", "/opening", "/live", "/day-end", "/sales/new", "/sales", "/payroll", "/wallet", "/id-archive", "/targets", "/comparison", "/reports", "/profile", "/ypp", "/settings"],
  personel: ["/", "/opening", "/day-end", "/sales/new", "/sales", "/targets", "/payroll", "/wallet", "/profile", "/ypp"],
};

export const ACTIONS = [
  { key: "act:delete_sales", label: "Satış silebilir", hint: "Kendi kapsamındaki satışlar (personel: kendi, müdür: şubesi)", roles: ["mudur"] },
  { key: "act:export", label: "Excel / PDF indirebilir", hint: "Rapor, hedef ve bordro çıktıları", roles: ["patron", "mudur", "personel"] },
  { key: "act:approve_id", label: "Kimlik onaylayabilir", hint: "Kimlik durumunu Tamam / Sorunlu işaretleme", roles: ["patron", "mudur"] },
  { key: "act:live_all", label: "Canlı Panel'de tüm şubeleri görür", hint: "Kapalıysa sadece kendi şubesini görür", roles: ["patron", "mudur"] },
  { key: "act:live_targets", label: "Canlı Panel'de şube hedef / HGO görür", hint: "Şube kartlarındaki hedef ve gerçekleşme yüzdesi", roles: ["patron", "mudur", "personel"] },
  { key: "act:live_details", label: "Diğer şubelerin satış detaylarını görür", hint: "Ürün ve personel bilgisi; kapalıysa diğer şubelerde sadece adetler görünür", roles: ["patron"] },
  { key: "act:edit_sales", label: "Satış düzenleyebilir", hint: "Personel: kendi satışı 1 saat içinde · Müdür: şubesi aynı gün", roles: ["mudur", "personel"] },
  { key: "act:ypp_all", label: "Tüm personel puan sıralamasını görür", hint: "Yatırımcı Performans Primi'nde şirket geneli personel sıralaması", roles: ["patron", "personel"] },
  { key: "view_revenue", label: "Kazanç bilgisini görebilir", hint: "Canlı Panel ₺, Günün Yıldızı tutarı, ürün ortalama geliri", roles: [] },
];

export function canAct(user, key, perms = user?.permissions) {
  if (!user) return false;
  if (isAdmin(user)) return true;
  const a = ACTIONS.find((x) => x.key === key || x.key === `act:${key}`);
  const o = perms?.[a.key];
  return typeof o === "boolean" ? o : a.roles.includes(user.role);
}

export const isAdmin = (u) => (u?.role === "koordinator" || u?.role === "patron") && !u?.custom_role_id;

export function canAccess(user, path, perms = user?.permissions) {
  if (!user) return false;
  const def = (ROLE_DEFAULTS[user.role] || []).includes(path);
  if (isAdmin(user)) return def;
  if (user.custom_role_id && PAGES.find((p) => p.to === path)?.adminOnly) return false;
  const o = perms?.[`page:${path}`];
  return typeof o === "boolean" ? o : def;
}

export const canViewRevenue = (user) => canAct(user, "view_revenue");

export const navFor = (user) =>
  PAGES.filter((p) => canAccess(user, p.to)).map((p) => ({ ...p, label: p[user.role] || p.label }));
